export interface IStates {
    states: IState[];
}

export interface IState {
    name: string;
    state_code: string;
}
